import * as apiClientV1 from '@/api/generated/v1/sdk.gen'
import * as apiClientV2 from '@/api/generated/v2/sdk.gen'
import { client as clientV1 } from '@/api/generated/v1/client.gen'
import { client as clientV2 } from '@/api/generated/v2/client.gen'
import { API_ROOT } from '@/config'
import { useAuthStore } from '@/ContextTab/stores/auth/auth'
import type { Config } from '@hey-api/client-axios'
import type { _Error as ApiError } from '@/api/generated/v2'


// const UNAUTHORIZED_STATUS_CODE = 401

const X_SESSION_ID = 'X-Session-ID'
const X_CORRELATION_ID = 'X-Correlation-ID'

function getCorrelationId(sessionId: string | null) {
  return `${sessionId}--APP`
}


function getBaseURL(version: 'v1' | 'v2') {
  // заменяем строку с версией на ту, что пришла в параметре version
  return API_ROOT.replace(/\/v\d+/, `/${version}`)
}

function initApiClient() {
  const authStore = useAuthStore()

  const headers = {
    [X_SESSION_ID]: authStore.sessionId,
    [X_CORRELATION_ID]: getCorrelationId(authStore.sessionId),
  }

  clientV1.setConfig({
    baseURL: getBaseURL('v1'),
    auth: () => 'Bearer ' + authStore.accessToken,
    headers,
  })

  clientV2.setConfig({
    baseURL: getBaseURL('v2'),
    auth: () => authStore.accessToken || '',
    headers,
  })

  // https://www.bezkoder.com/axios-interceptors-refresh-token/
  // client.instance.interceptors.response.use(
  //   (res) => res,
  //   async (error) => {
  //     const originalConfig = error.config
  //     if (error.response) {
  //       if (error.response.status === UNAUTHORIZED_STATUS_CODE && !originalConfig._retry) {
  //         originalConfig._retry = true
  //
  //         // обновление токенов
  //         const { data } = await apiClient.UserService.postUserToken()
  //         setToken(data?.data?.access_token)
  //         // повторяем исходный запрос
  //         return client.request(originalConfig)
  //       }
  //     }
  //
  //     return Promise.reject(error)
  //   },
  // )
}

function setRequestHeaders(headers: Config['headers']) {
  clientV1.setConfig({
    headers,
  })

  clientV2.setConfig({
    headers,
  })
}

export {
  // АПИ-клиенты, которыми можно пользоваться
  apiClientV1,
  apiClientV2,

  // Вспомогательные функции, типы и константы
  X_SESSION_ID,
  X_CORRELATION_ID,
  getCorrelationId,
  setRequestHeaders,
  type ApiError,

  // Функция инициализации
  initApiClient,
}
